<div class="main-banners__gallery" *ngIf="MainBannersView === MBTypes.NewsGallery"
  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-4' : 'mt-6 mr-3'}}">

  <div class="main-banners__loading animated faster fadeIn" *ngIf="MainBannerNewsLoading">
    <div class="ui-loader ui-loader__page-light"></div>
  </div>

  <div class="main-banners__slide">
    <ng-container *ngFor="let News of MainBannerNewsListData; let i = index">
      <div class="main-banners__gallery-item">
        <div class="main-banners__gallery-text">
          <div class="main-banners__gallery-text_heading" [ngStyle]="{'-webkit-box-orient': 'vertical'}">
            <a routerLink="/{{Routing.News}}/{{News.id}}" target="_blank">
              <h5>{{onTextHeadingSplit(News.title)}}</h5>
            </a>
          </div>
          <div class="main-banners__gallery-text_date">
            <span class="mr-icon mr-icon-clock"></span>
            <span>{{News.created | formatDate}}</span>
          </div>
        </div>
        <img src="{{StaticURL}}{{News.picUrl}}" *ngIf="!MainBannerNewsThumbnailError" (error)="MainBannerNewsThumbnailError = true">
      </div>
    </ng-container>
  </div>
  <div class="main-banners__gallery-nav">
    <div class="main-banners__gallery-nav-prev">
      <span class="mr-icon mr-icon-arrow-slide-prev"></span>
    </div>
    <div class="main-banners__gallery-nav-next">
      <span class="mr-icon mr-icon-arrow-slide-next"></span>
    </div>
  </div>
</div>

<div class="main-banners__vertical-banner" *ngIf="MainBannersView === MBTypes.VerticalBanner"
  ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'mt-6' : 'mt-6 ml-3'}}">

  <div class="main-banners__loading animated faster fadeIn" *ngIf="VerticalBannerNewsLoading">
    <div class="ui-loader ui-loader__page-light"></div>
  </div>

  <ng-container *ngFor="let News of VerticalBannerNewsListData; let i = index">
    <div class="main-banners__vertical-banner-item" ngClass="{{i === 0 ? 'mb-3' : 'mt-3'}}">
      <div class="grid flex-column justify-content-center main-banners__vertical-banner-text">
        <div class="main-banners__vertical-banner-text_heading" [ngStyle]="{'-webkit-box-orient': 'vertical'}">
          <a routerLink="/{{Routing.News}}/{{News.id}}" target="_blank">
            <h3>{{News.title}}</h3>
          </a>
        </div>
        <div class="main-banners__vertical-banner-text_date">
          <span class="mr-icon mr-icon-clock"></span>
          <span>{{News.created | formatDate}}</span>
        </div>
      </div>
      <img src="{{StaticURL}}{{News.picUrl}}" *ngIf="!VerticalBannerNewsThumbnailError" (error)="VerticalBannerNewsThumbnailError = true">
    </div>
  </ng-container>
</div>
